export default __webpack_public_path__ + "static/media/Success.41dba2a2.png";